// export const environment = {
//   production: false,
//   apiEndpoint: 'https://testadmin.katria.no/admin/v1/api',
//   apiEndpointV2: 'https://testadmin.katria.no/admin1/api/v2',
//   // For google map api
//   apiKey: 'AIzaSyB1h2u7SeTElFN93iG7LiZjQuOWnNmqDiM',
//   version: 'weekly',
//   // for Image Link
//   basePath: 'https://dev-sumo-online-order.s3.eu-west-1.amazonaws.com/',
//   // for json path
//   jsonPath: 'assets/json',
//   buttonLoaderMinTime: 2000, //milli second
//   ORGANIZATION_NAME: 'Katria',
// };
export const environment = {
  production: true,
  VERSION_SERVER: window['env']['VERSION_SERVER'],
  LAST_UPDATE: window['env']['LAST_UPDATE'],
  apiEndpoint: window['env']['apiEndpoint'],
  apiEndpointV2: window['env']['apiEndpointV2'],
  apiKey: window['env']['apiKey'],
  version: window['env']['version'],
  basePath: window['env']['basePath'],
  jsonPath: window['env']['jsonPath'],
  buttonLoaderMinTime: window['env']['buttonLoaderMinTime'],
  ORGANIZATION_NAME: window['env']['ORGANIZATION_NAME'],
};
